import axios from "axios";
import {
  LOGIN_ADMIN,
  GET_ARTICLES,
  GET_USERS,
  GET_CATEGORIES,
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  DELETE_ARTICLE,
  ENABLE_CATEGORY,
  TOGGLE_WRITER_STATUS,
  GET_DASHBOARD,
  GET_BANNERS,
  GET_VISITORS,
  GET_VISITORS_CHART,
  GET_VISITOR_PAGES,
  CREATE_BANNER,
  TOGGLE_BANNER_STATUS,
  DELETE_BANNER,
} from "./endpoints";
import { getAuthToken } from "./auth";

const api = axios.create({
  baseURL: "https://api.media24hr.com/api/admin",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    return Promise.reject(error);
  },
);

async function get(url, params) {
  try {
    const { data } = await api.get(url, { params });
    return { isError: false, data, error: null };
  } catch (error) {
    return { isError: true, error, data: null };
  }
}

export const getArticles = async (params) => get(GET_ARTICLES, params);
export const getUsers = async () => get(GET_USERS);
export const getCategories = async () => get(GET_CATEGORIES);
export const getDashboard = async () => get(GET_DASHBOARD);
export const getBanners = async () => get(GET_BANNERS);
export const getVisitors = async (params) => get(GET_VISITORS, params);
export const getVisitorsChart = async (params) => get(GET_VISITORS_CHART, params);
export const getVisitorPages = async (params) => get(GET_VISITOR_PAGES, params);
export const createCategory = (payload) => api.post(CREATE_CATEGORY, payload);
export const createBanner = (payload) => api.post(CREATE_BANNER, payload);
export const deleteCategory = (id) => api.delete(`${DELETE_CATEGORY}/${id}`);
export const enableCategory = (uid) => api.put(`${ENABLE_CATEGORY}/${uid}/enable`);
export const deleteArticle = (uid) => api.delete(`${DELETE_ARTICLE}/${uid}`);
export const toggleWriterStatus = (uid) =>
  api.put(`${TOGGLE_WRITER_STATUS}/${uid}/toggle-status`);
export const toggleBannerStatus = (uid) =>
  api.put(`${TOGGLE_BANNER_STATUS}/${uid}/toggle-status`);
export const deleteBanner = (uid) => api.delete(`${DELETE_BANNER}/${uid}`);
export const loginAdmin = (payload) => api.post(LOGIN_ADMIN, payload);

export async function uploadBannerImage(file) {
  const form = new FormData();
  form.append("image", file);
  try {
    const response = await axios.post("https://image.media24hr.com/upload", form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    return {
      data: response.data,
      error: null,
      isError: false,
    };
  } catch (error) {
    return {
      data: null,
      error,
      isError: true,
    };
  }
}

export default api;
